import React, { useMemo, startTransition } from 'react';
import { Checkbox, Space } from 'antd';
import { useFilterStore } from '../../store/useFilters';
import { Ambassador } from '../../types';
import { arteliaColors } from '../../theme';

interface BusinessUnitFilterProps {
  ambassadors: Ambassador[];
}

const BusinessUnitFilter: React.FC<BusinessUnitFilterProps> = ({ ambassadors }) => {
  const { filters, setBusinessUnitFilter } = useFilterStore();

  // Get unique business units with counts
  const businessUnitData = useMemo(() => {
    const buCounts = ambassadors.reduce((acc, ambassador) => {
      const bu = ambassador.businessUnit;
      if (bu) {
        acc[bu] = (acc[bu] || 0) + 1;
      }
      return acc;
    }, {} as Record<string, number>);

    return Object.entries(buCounts)
      .map(([businessUnit, count]) => ({ businessUnit, count }))
      .sort((a, b) => b.count - a.count);
  }, [ambassadors]);

  const handleBusinessUnitChange = (businessUnit: string, checked: boolean) => {
    startTransition(() => {
      const newBusinessUnits = checked
        ? [...filters.businessUnits, businessUnit]
        : filters.businessUnits.filter(bu => bu !== businessUnit);
      setBusinessUnitFilter(newBusinessUnits);
    });
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }} size={4}>
      {businessUnitData.map(({ businessUnit, count }) => (
        <div 
          key={businessUnit}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: '4px 0',
            width: '100%',
          }}
        >
          <Checkbox
            checked={filters.businessUnits.includes(businessUnit)}
            onChange={(e) => handleBusinessUnitChange(businessUnit, e.target.checked)}
            style={{ fontSize: '12px' }}
          >
            <span style={{ fontSize: '12px' }}>{businessUnit}</span>
          </Checkbox>
          <span 
            style={{
              fontSize: '10px',
              color: '#999',
              backgroundColor: '#f5f5f5',
              padding: '2px 6px',
              borderRadius: '8px',
              minWidth: '20px',
              textAlign: 'center',
            }}
          >
            {count}
          </span>
        </div>
      ))}
    </Space>
  );
};

export default BusinessUnitFilter;